<template>
    <v-dialog v-model="open" persistent max-width="400px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn block color="primary" dark v-bind="attrs" v-on="on">
                Email Messages
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Email Messages</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-list v-if="emailTemplates.length > 0">
                <v-list-group
                    v-for="template in emailTemplates"
                    :key="template.id"
                    v-model="template.active"
                    no-action
                >
                    <template v-slot:activator>
                        <v-container>
                            <v-list-item-content>
                                <v-list-item-title v-text="template.name"></v-list-item-title>
                            </v-list-item-content>
                        </v-container>
                    </template>
                    <EmailMessageForm :template="template" />
                </v-list-group>
            </v-list>
            <v-list v-else>
                <v-list-item class="d-flex justify-center">
                    No templates
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="() => (open = false)">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="create">
                    Create
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from "vuex";
import EmailMessageForm from "@/components/forms/EmailMessageForm";

export default {
    name: "EmailMessagesDialog",
    components: {
        EmailMessageForm,
    },
    data() {
        return {
            open: false,
        };
    },
    computed: {
        ...mapGetters({
            emailTemplates: "templates/emails",
            user: "auth/user",
        }),
    },
    methods: {
        ...mapActions({
            loadEmails: "templates/loadEmails",
            showHandlerSnackbar: "snackbar/showHandlerSnackbar",
        }),
        ...mapMutations({
            ADD_EMAIL: "templates/ADD_EMAIL",
        }),
        create() {
            this.$axios.post('/templates/email/create', {
                user_id: this.user.id,
                name: "New Template",
                title: "",
                text: "",
            }).then(res => {
                this.ADD_EMAIL(res.data.template);

                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });

                this.emailTemplates.map(t => {
                    if (t.id === res.data.template.id) {
                        t.active = true;
                    } else {
                        t.active = false;
                    }

                    return t;
                });
            }).catch(e => {
                console.error(e);
            });
        }
    },
    mounted() {
        this.loadEmails(this.user.id);
    },
};

</script>